module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 8 – 2-d665b1fb6c7bde81d45679dfd5dbebe9.svg";